<template>
  <div class="ship-info">
    <div class="title">
      Shipping Methods
    </div>
    <div class="sub-title">
      Your order shipping & delivery with
      <Icon
        name="bestdealer-logo"
        class="ship-info__logo"
      />
    </div>
  </div>
  <div class="delivery">
    <ShippingSelect />
    <div class="target-address">
      <div class="address">
        <img
          :src="countryUrl"
          alt=""
        >
        <template v-if="addressStore.cacheAddress">
          {{ addressStore.cacheAddress.city }}
          <span
            @click="changeAddress"
            class="suffix change"
          >Change</span>
        </template>
        <template v-else>
          Ship to My Address
          <span
            class="suffix"
            @click="changeAddress"
          >Add new address</span>
        </template>
      </div>
      <div class="est-time">
        Estimated Delivery Time:
        <template v-if="addressStore.cacheAddress">
          <span>{{ deliveryTime.min }} - {{ deliveryTime.max }}</span> days
        </template>
        <template v-else>
          Unavailable
        </template>
      </div>
    </div>
    <p
      class="ship-info-error"
      v-if="hasUndeliverableSelected"
    >
      <Icon name="icon-warning-outline" />
      Undeliverable Logistics
    </p>
  </div>
</template>

<script setup>
import { Icon } from '@/components/Icon'
import { useAddressStore } from '@/pinia/address'
import { useShipStore } from '@/pinia/ship'
import { ShippingSelect } from '@/views/Carts/components/ShippingSelect'
import { useOrder } from '@/views/Carts/hooks/useOrder'

const { deliveryTime, hasUndeliverableSelected } = useOrder()
const addressStore = useAddressStore()
const ship = useShipStore()

const countryUrl = computed(() => addressStore.cacheAddress ? addressStore.cacheAddress.searchImg : ship.country.countryUrl)

const changeAddress = () => {
  addressStore.show(3)
}
</script>

<style lang='less' scoped>
.ship-info {
  color: #232323;
  .title {
    font-size: 14px;
    font-family: mon-700;
    line-height: 18px;
  }
  .sub-title {
    font-size: 11px;
    font-family: mon-500;
    line-height: 14px;
    margin-top: 6px;
  }

  &__logo {
    display: block;
    width: 74px;
    height: 16px;
    color: #1153D6;
  }

  &-error {
    margin-top: 6px;
    display: flex;
    align-items: center;
    gap: 2px;
    font-family: mon-600;
    font-size: 11px;
    line-height: 14px;
    color: #7A0505;

    &__icon {
      font-size: 14px;
    }
  }
}
.delivery {
  margin-top: 8px;

  .target-address {
    margin-top: 12px;
    .address {
      display: flex;
      align-items: center;
      gap: 6px;
      color: #232323;
      font-size: 12px;
      font-family: mon-600;
      img {
        width: 16px;
        object-fit: contain;
      }
      .suffix {
        color: #007EB3;
        text-decoration: underline;
        cursor: pointer;
        &.change {
          font-family: mon-500;
          color: #232323;
        }
        &:hover {
          color: var(--link-hover-color);
        }
      }
    }
    .est-time {
      margin-top: 6px;
      color: #232323;
      font-size: 11px;
      font-family: mon-500;

      > span {
        font-family: mon-700;
        color: #529426;
      }
    }
  }
}
</style>
